{
  "moreActions": "Więcej akcji",
  "unavailable": "Niedostępne, rozwiń, aby zobaczyć szczegóły"
}
